export default __webpack_public_path__ + "static/media/mailchannels.d8217977.svg";